import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'
import { EventDebits } from '../../types/event-debits'

export interface useBalanceDistributionProps {
  balance: AxiosResponse<FetchResponse> | undefined
  isLoading: boolean
  isError: AxiosError
}

interface DataItem {
  label: string
  value: number
  percentage: number
}

interface ResponseBody {
  data: DataItem[]
  totalValue: number
  avaliable: boolean
  message?: string
  totalPercentage: number
  fechamentoStatus: string
  dataAgendamentoMinimo: string
  eventDebits?: EventDebits
}

interface FetchResponse {
  success: boolean
  body: ResponseBody
}

export const useBalanceDistribution = (
  id: number,
  forceBalance: boolean | undefined = false
): useBalanceDistributionProps => {
  let url: string = `producer/analytics/balanceDistribution?eventId=${id}`
  const option = '&forceReturnBalance=true'
  if (forceBalance !== undefined && forceBalance) {
    url = url + option
  }

  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR(url, fetchData, {
    refreshInterval: 60000 * 3,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })
  return {
    balance: data,
    isLoading,
    isError: error,
  }
}
